<template>
  <v-app>
    <!--<v-toolbar app color="#388E3C">-->
      <!--<v-toolbar-title class="headline white&#45;&#45;text">-->
        <!--<span class="display-1" >Donnert</span>-->
        <!--<span class="title"> - 택배 조회</span>-->
      <!--</v-toolbar-title>-->
      <!--<v-spacer>-->
      <!--</v-spacer>-->
    <!--</v-toolbar>-->
    <!--<v-toolbar app >-->
      <!--<v-toolbar-title class="headline">-->
        <!--&lt;!&ndash;<span class="display-title" >Delivery tracking</span>&ndash;&gt;-->
        <!--&lt;!&ndash;<span class="display-1" >Donnert</span>&ndash;&gt;-->
        <!--&lt;!&ndash;<span class="title"> - 택배 조회</span>&ndash;&gt;-->
      <!--</v-toolbar-title>-->
      <!--<v-spacer>-->
      <!--</v-spacer>-->
      <!--<v-toolbar-items class="hidden-sm-and-down">-->
        <!--<v-btn flat @click="goHomepage">donnert</v-btn>-->
      <!--</v-toolbar-items>-->
    <!--</v-toolbar>-->

    <!--<InFeedAdsense-->
      <!--data-ad-layout-key="-6t+ed+2i-1n-4w"-->
      <!--data-ad-client="ca-pub-4697305889011107"-->
      <!--data-ad-slot="5822799445">-->
    <!--</InFeedAdsense>-->
    <v-content>
      <v-container >
        <!--<v-container grid-list-xl>-->
        <router-view></router-view>
      </v-container>
      <!--<HelloWorld/>-->
    </v-content>
    <v-flex mt-2></v-flex>
    <!--<v-flex>-->
      <!--<InFeedAdsense-->
        <!--data-ad-layout-key="-6t+ed+2i-1n-4w"-->
        <!--data-ad-client="ca-pub-4697305889011107"-->
        <!--data-ad-slot="5822799445">-->
      <!--</InFeedAdsense>-->
    <!--</v-flex>-->
    <v-footer
              color="secondary lighten-1"
    >

      <v-spacer></v-spacer>
      <v-btn flat
             small
             class="white--text"
             @click="goHomepage"
             style="margin-bottom: 2px"
      >donnert</v-btn>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      //
    }
  },
  methods: {
    goHomepage: function () {
      window.open('http://donnert.net', '_blank')
    }
  }
}
</script>

<style >
  .application {
    font-family: 'Nanum Gothic', sans-serif;
  }
  .caption {
    color: gray;
    font-size: 12px;
  }
  .v-parallax__content {
    padding:0px;
  }
  /*.v-parallax__image {*/
    /*filter:blur(3px)*/
  /*}*/
  .lightbox2 {
    background:rgba(0,0,0,0.3);
  }
  .gray--text {
    color: gray;
  }
  .noscroll {
    position: fixed;
    overflow-x: hidden;
    overflow-y: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue